import React from 'react';
import { Share2, Link2 } from 'lucide-react';

const ProfileHeader = ({ profileData, username }) => {
  const baseUrl = import.meta.env.VITE_APP_URL || 'https://dev.skillsture.io'
  const profileUrl = `${baseUrl}/profile/${username}`;
  let fullName = profileData.fullName || profileData.first_name || '';
  fullName = profileData.last_name ? `${fullName} ${profileData.last_name}` : fullName;
  let totalBadges = profileData.total_badges || 0;
  let totalPassports = profileData.total_passports || 0;
  let credentialsCount = totalBadges + totalPassports;

  const handleCopyProfile = async () => {
    try {
      await navigator.clipboard.writeText(profileUrl);
      alert('Profile link copied to clipboard!');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const handleShareProfile = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `Sharing ${fullName}'s Public Profile`,
          text: `${fullName}'s SKILLSTRUE Page`,
          url: profileUrl, // Replace with your desired URL
        });
        console.log('Content shared successfully');
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      // Fallback for browsers that don't support the Web Share API
      alert('Web Share API is not supported in this browser.');
      // You could also implement a custom share dialog here
    }
  }

  return (
    <div className="text-white my-4">
      <div className="flex flex-col justify-start items-start">
        {/* <div> */}
          <h1 className="text-base font-bold">{fullName}</h1>
          <p className="text-sm text-white/80 mt-1">{credentialsCount || 0} Credentials</p>
        {/* </div> */}
        
        <div className="flex mt-3 space-x-3">
          
          <button className="text-center space-x-2 bg-blue-500 hover:bg-white border border-blue-500 hover:text-black text-white px-2 py-1.5 rounded-sm transition-colors text-sm font-normal"
            onClick={handleShareProfile}>
            <Share2 size={16} className="inline-block -mt-1" />
            <span>Share Profile</span>
          </button>
          
          <button className="text-center space-x-2 bg-white hover:bg-blue-500 border border-white text-black hover:text-white px-2 py-1.5 rounded-sm transition-colors text-sm font-normal"
            onClick={handleCopyProfile}>
            <Link2 size={16} className="inline-block -mt-1" />
            <span>Copy Link</span>
          </button>
        </div>
      </div>
      
      <div className="mt-4 p-2 bg-gray-900/30 border border-white rounded-md">
        <p className="text-sm text-white break-all">{profileUrl}</p>
      </div>
    </div>
  );
};

export default ProfileHeader;